<template>
  <v-container>
    <div class="head-title mb-4">
      <h1 class="display-1">Activer un compte</h1>
    </div>
    <HeaderTable>
      <v-data-table :headers="headers" :items="items" :search="search" no-results-text="Votre recherche n'a retourné aucun resultat" footer-props.items-per-page-text="Éléments par page" no-data-text="Aucune donnée disponible.">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.id }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </HeaderTable>
  </v-container>
</template>

<script>
  import HeaderTable from '@/components/helpers/HeaderTable.vue'
  export default {
    name: 'ActiverCompte',
    data: () => ({
      headers: [],
      items: [],
      search: ''
    }),
    components: {
      HeaderTable
    }
  }
</script>

<style scoped>

</style>